module.exports = __webpack_public_path__ + "static/media/pic13.da27eea5.jpg";